<template>
  <div>
    <!-- <task-detail @onSave="refreshStages" @onDelete="refreshStages" /> -->
    <task-detail />

    <b-row>
      <b-col md="9" offset-md="1">
        <h1 class="title text-center mb-4">{{ $t("roadmap.bgys.text") }}</h1>
        <div class="alert alert-info m-4 text-justify">
          <h6>
            {{ $t("roadmap.bgys-init-alert") }}
          </h6>
          <h6>
            {{ $t("roadmap.bgys-init-alert-2") }}
          </h6>
          <h6>
            {{ $t("roadmap.init-alert") }}
          </h6>
        </div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="9" offset-md="1" class="position-relative">
        <Stage
          roadmapDefinition="BGYS_PRODUCT_ROADMAP"
          definition="BGYS_ORGANIZATION_CONTEXT"
          :customStyle="customStyle"
          :title="$t('roadmap.stage.bgys-organization-context')"
          :lines="['center']"
        />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="9" offset-md="1" class="position-relative">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_LEADERSHIP" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-leadership')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="9" offset-md="1" class="position-relative">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_PLANNING" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-planning')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="9" offset-md="1" class="position-relative">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_SUPPORT" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-support')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="9" offset-md="1">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_OPERATION" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-operation')" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9" offset-md="1">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_PERFORMANCE_RATING" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-performance-rating')" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9" offset-md="1">
        <Stage roadmapDefinition="BGYS_PRODUCT_ROADMAP" definition="BGYS_IMPROVEMENT" :customStyle="customStyle" :title="$t('roadmap.stage.bgys-improvement')" />
      </b-col>
    </b-row>

    <!---->
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import Stage from "./component/roadmap-stage";

export default {
  components: { Stage },
  mounted() {
    const stages = ["BGYS_ORGANIZATION_CONTEXT", "BGYS_LEADERSHIP", "BGYS_PLANNING", "BGYS_SUPPORT", "BGYS_OPERATION", "BGYS_PERFORMANCE_RATING", "BGYS_IMPROVEMENT"];

    EventBus.$on("task-board-update", (e) => {
      stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });

    EventBus.$on("roadmap-stage-updated", (e) => {
      e.stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
  },
  data() {
    return {
      customStyle: `
        max-width: 55rem;

      `,
    };
  },
  methods: {
    // refreshStages(item) {
    //   setTimeout(() => {
    //     const stage = item?.relations?.roadmapStage;
    //     if (stage?.roadmapDefinition == "BGYS_PRODUCT_ROADMAP") {
    //       this.loadStage(stage?.definition);
    //       stage.next.forEach((s) => this.loadStage(s));
    //     }
    //   }, 4000);
    // },
    async loadStage(stage) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`organizationRoadmap/loadStage`, { roadmap: "BGYS_PRODUCT_ROADMAP", stage });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./roadmap";
</style>
